<template>
  <div v-if="element" class="element-wrapper" :data-_key="element._key">
    <div v-if="loading">loading...</div>
    <BaseEchart ref="dynamicalChart" v-else :theme="element.chartTheme" :advanceMode="element.compData.advanceMode" :option="element.compData.advanceMode ? element.compData.advanceCode : element.compData.chartData" @click="handleElementClick" @finished="handleElementFinish"></BaseEchart>
    <div v-if="tooltipFontStyle" v-html="tooltipFontStyle"></div>
    <div v-if="legendFontStyle" v-html="legendFontStyle"></div>
  </div>
</template>

<script>
import "view-design/dist/styles/iview.css";
import BaseEchart from "./BaseEchart";
import {
  post,
  getRealOption
} from "@/util";
import { fontFamily } from "@/util/editor/fonts/fontFamily";

export default {
  methods: {
    async init() {
      //每次初始化重置onmounted
      this.mountedIndex = 0;
      const { chartData } = this.element.compData || {};
      if (!chartData) return;
      // 静态图表
      this.loading = false;
      this.handleUpdateTooltipFontStyle()
      this.handleUpdateLegendFontStyle()
    },
    /**
     * 动态添加自定义字体
     */
    handleUpdateTooltipFontStyle() {
      if(this.element.compData.advanceMode) return
      if (!this.chartOption || !this.chartOption.tooltip || !this.chartOption.tooltip.textStyle || this.chartOption.tooltip.textStyle.fontFamily == null) return
      console.log(this.chartOption.tooltip.textStyle.fontFamily, '// 33')
      const font = fontFamily.filter( it => it.name === this.chartOption.tooltip.textStyle.fontFamily)[0] || {}
      if (!font.name || font.name == '') return
      this.tooltipFontStyleName = font.name
      this.tooltipFontStyleUrl = font.url
    },
    /**
     * 动态添加自定义字体 表格主体
     */
    handleUpdateLegendFontStyle() {
      if(this.element.compData.advanceMode) return
      if (!this.chartOption || !this.chartOption.legend || !this.chartOption.legend.textStyle ||this.chartOption.legend.textStyle.fontFamily == null) return
      console.log(this.chartOption.legend.textStyle.fontFamily, '// 44')
      const font = fontFamily.filter( it => it.name === this.chartOption.legend.textStyle.fontFamily)[0] || {}
      if (!font.name || font.name == '') return
      this.legendFontStyleName = font.name
      this.legendFontStyleUrl = font.url
    },
    // 轮询处理动态图表数据
    async handleLoopFetch() {
      const {
        _key,
        chartData,
        chartOption,
        chartData: { api },
        eventsBinding: { list: eventsList },
      } = this.element || null;
      let { dynamicServer } = this.$EventBus || null;

      // 去掉最后的斜杠
      dynamicServer =
        dynamicServer && dynamicServer[dynamicServer.length - 1] === "/"
          ? dynamicServer
          : dynamicServer + "/";

      const connectQuery = {
        api: chartData.api,
        apiType: chartData.apiType,
        body: chartData.body,
        path: chartData.path,
      };
      const connectResult = await post(
        dynamicServer + "api/charts/connect",
        connectQuery
      );
      // console.log(connectResult, '// connectResult33333')
      const data = chartData.data.map((item) => {
        return {
          ...item,
          data: connectResult.data[`${item.data}`],
        };
      });
      const previewQuery = {
        data,
        name: chartData.name,
        color: chartData.color,
        type: chartData.type,
        dataType: chartData.dataType,
        subtext: chartData.subtext,
        max: chartData.max,
        categoryData: connectResult.data[chartData.categoryData],
      };
      // 测试动态图表 mock接口
      // const test = 'http://127.0.0.1:8989/mock/452/wdt/api/charts/preview'
      // const previewResult = await post(test, previewQuery)
      const previewResult = await post(
        dynamicServer + "api/charts/preview",
        previewQuery
      );
      if (!previewResult) return;

      // 使用自定义的color
      const { color } = getRealOption(chartOption);
      let newOption = getRealOption(previewResult.data);
      newOption = {
        ...newOption,
        color,
      };
      this.dynamicalChartOption = JSON.stringify(newOption);

      // this.$refs.dynamicalChart.handleUpdataDynamical(newOption)
      // console.dir(newOption, '// 动态数据组装 newOption')
      // myChart && myChart.off('click')
      // myChart.clear()
      // myChart.setOption(newOption)
      // myChart.on('click', handleChartClick)
    },
    handleElementClick(params) {
      console.log(params);
      let echartItem = {
        x: params.name,
        y:
          params.seriesIndex || params.seriesIndex === 0
            ? params.data[params.seriesIndex + 1]
            : "",
        s: params.seriesName,
      };
      console.log(echartItem);
      this.plugin &&
        this.plugin.id &&
        this.$blueMap.trigger({
          nodeType: "plugin",
          pluginId: this.plugin.id,
          dataKey: "onclick",
          eventData: {
            value: echartItem,
            data: this.plugin,
            event: null,
          },
        });
    },
    // 初始化完成时加载  echart finished事件
    handleElementFinish() {
      if (this.mountedIndex === 0) {
        this.plugin &&
          this.plugin.id &&
          this.$blueMap.trigger({
            nodeType: "plugin",
            pluginId: this.plugin.id,
            dataKey: "onmounted",
            eventData: {
              value: null,
              data: this.plugin,
              event: null,
            },
          });
        this.mountedIndex++;
      }
    },
  },
  beforeDestroy() {
    this.$ele &&
      this.$ele.removeEventListener("click", this.handleElementClick);
    this.$ele &&
      this.$ele.removeEventListener("finished", this.handleElementFinish);
  },
  computed: {
    plugin: function () {
      return this.$getPlugin(this.element.id);
    },
    chartOption() {
      if (!this.element || this.element.compData.chartData == null) return
      const { chartData } = this.element.compData || {}
      let option
      // 拼接有效的option字符串
      let evalStr = `option = ${chartData}`
      // 运行语句
      try {
        eval(evalStr)
      } catch (t) {
        console.log(t)
      }
      return option
    },
    // 组件字体style html
    tooltipFontStyle() {
      if (!this.tooltipFontStyleName || this.tooltipFontStyleName == '' || !this.tooltipFontStyleUrl || this.tooltipFontStyleUrl == '' ) return
      return `<style>
        @font-face {
          font-family: ${this.tooltipFontStyleName};
          ${this.tooltipFontStyleUrl !== '' ? 'src: url(' + this.tooltipFontStyleUrl + ')' : ''}
        }
      </style>`
    },
    // 组件字体style html代码 表格内容
    legendFontStyle() {
      if (!this.legendFontStyleName || this.legendFontStyleName == '' || !this.legendFontStyleUrl || this.legendFontStyleUrl == '' ) return
      return `<style>
        @font-face {
          font-family: ${this.legendFontStyleName};
          ${this.legendFontStyleUrl !== '' ? 'src: url(' + this.legendFontStyleUrl + ')' : ''}
        }
      </style>`
    },
  },
  props: {
    element: {
      type: Object,
      default: null,
      require: true,
    },
  },
  components: {
    BaseEchart,
  },
  data: () => {
    return {
      eventsBinding: null,
      mountedIndex: 0,
      isDynamical: null,
      loading: true,
      dynamicalChartOption: null,
      tooltipFontStyleName: null,
      tooltipFontStyleUrl: null,
      legendFontStyleName: null,
      legendFontStyleUrl: null
    };
  },
  name: "CompChart",
  mounted() {
    this.init();
  },
  watch: {
    // 侦听字体变化 表头
    'chartOption.tooltip.textStyle.fontFamily': function() {
      this.handleUpdateTooltipFontStyle()
    },
    // 侦听字体变化 表格主体
    'chartOption.legend.textStyle.fontFamily': function() {
      this.handleUpdateLegendFontStyle()
    }
  },
};
</script>

<style lang='less' scoped>
.element-wrapper {
  width: 100%;
  height: 100%;
}
</style>
